export const getColorwayId = (productId?: string, selectedColor?: string) => {
  if (!productId || !selectedColor) return ''
  return `${productId}_${selectedColor?.toUpperCase().split(' ').join('_') ?? ''}`
}
